import { useEffect, useRef, useState } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import { useAuth } from '../context/AuthContext';
import { crmAPI } from '../services/api';
import CrmLeadFormDialog from './CrmLeadFormDialog';

/**
 * Polls for accepted inbound calls and opens the CRM capture form for assigned agents.
 */
export default function CrmIncomingCallListener() {
  const { can, isAuthenticated } = useAuth();
  const queryClient = useQueryClient();
  const [activeLead, setActiveLead] = useState(null);
  const shownRef = useRef(new Set());

  const enabled = isAuthenticated && can('lead_requests');

  const pollMs = 20000;

  const { data } = useQuery(
    ['crm-incoming-popups'],
    () => crmAPI.incomingPopups(),
    {
      enabled,
      refetchInterval: enabled ? pollMs : false,
      refetchIntervalInBackground: false,
      staleTime: pollMs - 1000
    }
  );

  const popups = data?.data?.data || [];

  useEffect(() => {
    if (!popups.length) return;
    const next = popups.find((p) => p.source === 'crm_leads' && !shownRef.current.has(p.id));
    if (next && !activeLead) {
      shownRef.current.add(next.id);
      setActiveLead(next);
    }
  }, [popups, activeLead]);

  const handleClose = () => {
    if (activeLead?.id) {
      crmAPI.popupSeen(activeLead.id).catch(() => {});
    }
    setActiveLead(null);
  };

  const handleSaved = () => {
    queryClient.invalidateQueries(['crm-incoming-popups']);
    queryClient.invalidateQueries(['lead-requests']);
  };

  if (!enabled) return null;

  return (
    <CrmLeadFormDialog
      open={Boolean(activeLead)}
      onClose={handleClose}
      onSaved={handleSaved}
      mode="incoming"
      initial={activeLead}
      title={`Incoming call — ${activeLead?.phone || ''}`}
    />
  );
}
